import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
    const [enabled, setEnabled] = useState(false);
    const [hovering, setHovering] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const ringX = useSpring(x, { stiffness: 250, damping: 28, mass: 0.6 });
    const ringY = useSpring(y, { stiffness: 250, damping: 28, mass: 0.6 });
    const spotX = useSpring(x, { stiffness: 60, damping: 20 });
    const spotY = useSpring(y, { stiffness: 60, damping: 20 });

    useEffect(() => {
        if (!window.matchMedia("(pointer: fine)").matches) return;
        setEnabled(true);
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
        };
        const over = (e) => {
            setHovering(
                !!e.target.closest("a, button, [data-cursor='hover']"),
            );
        };
        window.addEventListener("pointermove", move, { passive: true });
        window.addEventListener("mouseover", over, { passive: true });
        return () => {
            window.removeEventListener("pointermove", move);
            window.removeEventListener("mouseover", over);
        };
    }, [x, y]);

    if (!enabled) return null;

    return (
        <>
            <motion.div
                aria-hidden="true"
                className="pointer-events-none fixed left-0 top-0 z-[110] h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full"
                style={{
                    x: spotX,
                    y: spotY,
                    background:
                        "radial-gradient(circle, rgba(200,169,106,0.07) 0%, rgba(255,255,255,0.03) 35%, transparent 70%)",
                }}
            />
            <motion.div
                aria-hidden="true"
                className="pointer-events-none fixed left-0 top-0 z-[115] -translate-x-1/2 -translate-y-1/2"
                style={{ x: ringX, y: ringY }}
            >
                <motion.div
                    className="rounded-full border border-gold/60"
                    animate={{
                        width: hovering ? 52 : 32,
                        height: hovering ? 52 : 32,
                        opacity: hovering ? 1 : 0.55,
                    }}
                    transition={{ duration: 0.25 }}
                    style={{ translateX: "-50%", translateY: "-50%" }}
                />
            </motion.div>
            <motion.div
                aria-hidden="true"
                className="pointer-events-none fixed left-0 top-0 z-[115] h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold"
                style={{ x, y }}
            />
        </>
    );
}
